export type EmailDropdownType = {
    id: string;
    email: string;
    placeholder?: string;
    setEmail(email: string): void;
    label?: string;
    hasError?: boolean;
    errorMessage?: string;
    readOnly?: boolean;
};

export enum EmailDropdownGroupEnum {
    Domains = 'Domains',
    Emails = 'Emails',
}

export type EmailDropdownOption = {
    name: string;
    group?: EmailDropdownGroupEnum;
};
